import React from "react";
import { rajyaSabhaDocuments } from "../../data/rtiDocuments";
import PdfDocumentTable from "./PdfDocumentTable";

const RajyaSabha = () => (
  <div className="min-w-0 flex-1">
    <h2 className="mb-4 text-[22px] font-bold text-[#006461]">
      Rajya Sabha
    </h2>
    <PdfDocumentTable documents={rajyaSabhaDocuments} />
  </div>
);

export default RajyaSabha;
